import { assign, each } from 'lodash';

const SocialIcons = {
  Facebook: {
    Icon: 'fab fa-facebook-f',
    Title: 'Facebook',
  },
  Twitter: {
    Icon: 'fa-brands fa-x-twitter',
    Title: 'X',
  },
  YouTube: {
    Icon: 'fab fa-youtube',
    Title: 'YouTube',
  },
  Instagram: {
    Icon: 'fab fa-instagram',
    Title: 'Instagram',
  },
  Flickr: {
    Icon: 'fab fa-flickr',
    Title: 'Flickr',
  },
  LinkedIn: {
    Icon: 'fab fa-linkedin-in',
    Title: 'LinkedIN',
  },
  Blog: {
    Icon: 'fab fa-blogger',
    Title: 'Blog',
  },
  Email: {
    Icon: 'fas fa-envelope',
    Title: 'Email',
  },
  Pintrest: {
    Icon: 'fab fa-pinterest',
    Title: 'Pinterest',
  },
  Snapchat: {
    Icon: 'fab fa-snapchat',
    Title: 'Snapchat',
  },
  RSS: {
    Icon: 'fas fa-rss',
    Title: 'RSS',
  },
};

// @var socialObj - dress link into a social icon
function SocialLink(socialObj) {
  const {
    Url, Window, Icon, Title,
  } = socialObj;
  const list = document.querySelectorAll('.social-links-loader');
  each([...list], (item) => {
    const element = document.createElement('a');
    element.setAttribute('title', Title);
    element.setAttribute('target', Window);
    element.setAttribute('href', Url);
    element.innerHTML = `<i class="${Icon}"></i>`;
    item.appendChild(element);
  });
}

// @var socialvars - receive dnn global variables & create social icons
function SocialLinkBuilder(socialvars) {
  if (socialvars) {
    each(Object.keys(SocialIcons), (key) => {
      const Url = (socialvars[key] && socialvars[key].Url)
        ? socialvars[key].Url
        : '';
      const Window = (socialvars[key] && socialvars[key].Window)
        ? socialvars[key].Window
        : '_blank';
      if (SocialIcons[key] && Url) {
        SocialLink(assign(SocialIcons[key], { Url, Window }));
      }
    });
  }
}

export default SocialLinkBuilder;
